class Camera {
  getPicture = (onSuccess: (base64: string) => void, onError = () => {}) => {
    window.launchCamera?.(onSuccess, onError);
  };
}

const camera = new Camera();

export default camera;
